import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { OptionsSuiviInterventionState, state } from '@/modules/OptionsSuiviInterventions/store/state';
import { mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';

const module: Module<OptionsSuiviInterventionState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { OptionsSuiviInterventionState };

